var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiagramReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3 12.7C32.04 9.43998 27.42 7.55998 22.34 8.07998C15 8.81998 8.95998 14.78 8.13998 22.12C7.03998 31.82 14.54 40 24 40C30.38 40 35.86 36.26 38.42 30.88C39.06 29.54 38.1 28 36.62 28C35.88 28 35.18 28.4 34.86 29.06C32.6 33.92 27.18 37 21.26 35.68C16.82 34.7 13.24 31.08 12.3 26.64C10.62 18.88 16.52 12 24 12C27.32 12 30.28 13.38 32.44 15.56L29.42 18.58C28.16 19.84 29.04 22 30.82 22H38C39.1 22 40 21.1 40 20V12.82C40 11.04 37.84 10.14 36.58 11.4L35.3 12.7V12.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramReset);
export default __webpack_public_path__ + "static/media/diagram_reset.d21e15ae7cb17f02ba0d424412428375.svg";
export { ForwardRef as ReactComponent };